<div class="option-content-particularity">
    <span class="option-title">Cláusula cobranza</span>

    <div class="actions">
        <input type="checkbox" class="checkbox" [checked]="isCollectionClause" (click)="setCollectionClause()" />
    </div>
</div>